export const normalizeApiBaseUrl = (value: string) => value
  // Browsers on some machines resolve localhost to ::1 first, while the local API only listens on IPv4.
  .replace(/^((?:https?):\/\/)localhost(?=[:/]|$)/i, '$1127.0.0.1')
  .replace(/\/+$/, '')

const resolveDefaultApiBaseUrl = () => {
  if (import.meta.env.PROD) {
    return '/api'
  }

  const configuredBaseUrl = normalizeApiBaseUrl(import.meta.env.VITE_API_BASE_URL || '')
  const isLocalBackendOrigin = /^https?:\/\/(?:127\.0\.0\.1|localhost):2012\/api$/i.test(configuredBaseUrl)

  // In dev we prefer the local Vite middleware so every request goes through the same proxy/auth/normalization path.
  if (!configuredBaseUrl || isLocalBackendOrigin) {
    return '/api'
  }

  return configuredBaseUrl
}

export const DEFAULT_API_BASE_URL = resolveDefaultApiBaseUrl()

export const API_BASE_URL = DEFAULT_API_BASE_URL.startsWith('/api')
  ? DEFAULT_API_BASE_URL
  : normalizeApiBaseUrl(DEFAULT_API_BASE_URL)
